import { useState } from 'react';

interface ISpinnerSelectorHook {
    quantity: number;
    maxQty: number;
    minQty?: number;
    selectorStep?: number;
    isCartQtyLimitExceeded: boolean;
    isCartQtyLimitReached: boolean;
    minCartQtyReached?: boolean;
    isDropdownDisabled?: boolean;
    onChange(val: number): Promise<void> | undefined;
}

export const useSpinnerSelector = (props: ISpinnerSelectorHook) => {
    const {
        quantity,
        selectorStep = 1,
        minQty = 0,
        maxQty,
        isCartQtyLimitExceeded,
        isCartQtyLimitReached,
        minCartQtyReached,
        isDropdownDisabled,
        onChange
    } = props;

    const [loading, setLoading] = useState(false);

    const isDisabled = loading || isDropdownDisabled;
    const step = isDisabled ? Infinity : selectorStep;

    const canDecrease = quantity - step >= minQty;
    const canIncrease = quantity + step <= maxQty;

    const disableDecrease = isDisabled || minCartQtyReached || !canDecrease;
    const disableIncrease = isDisabled || isCartQtyLimitExceeded || !canIncrease;

    const updateSelectedValue = async (value: number) => {
        if (onChange) {
            setLoading(true);
            await onChange(value);
            setLoading(false);
        }
    };

    const onRangeDecrease = () => {
        if (canDecrease) {
            updateSelectedValue(quantity - selectorStep);
        }
    };

    const onRangeIncrease = () => {
        if (canIncrease) {
            updateSelectedValue(quantity + selectorStep);
        }
    };

    return {
        quantityLoading: loading,
        quantity,
        maxQty,
        isCartQtyLimitExceeded,
        isCartQtyLimitReached,
        disableDecrease,
        disableIncrease,
        onRangeDecrease,
        onRangeIncrease
    };
};
